import { defineComponent as r, createBlock as n, openBlock as p, normalizeProps as a, guardReactiveProps as s, withCtx as m, renderSlot as l, createElementVNode as i } from "vue";
import u from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ r({
  name: "MinusStroke",
  __name: "minus-stroke",
  props: {
    props: {
      type: Object
    }
  },
  setup(t) {
    return (o, e) => (p(), n(u, a(s(t.props)), {
      default: m(() => [l(o.$slots, "default"), e[0] || (e[0] = i("path", {
        role: "presentation",
        d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-4-9h8a1 1 0 010 2H8a1 1 0 010-2z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
